import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';
import article1 from 'assets/csdd_images/article1_img.jpeg';
import article_img_1 from 'assets/csdd_images/about__us__pic__.jpg';

const data = [
  {
    headerImage: article_img_1,
    title:
      'Procurement Chamber trains private contractors and suppliers on accurate tender procedures',
    bodyImageAlt: 'Collection of certification from workshop',
    description:
      'The Chamber of Suppliers’ Development and Diversity (CSDD), a chamber for private contractors and suppliers of public goods and services...',
    body: (
      <MKTypography variant='subtitle1' textAlign='justify'>
        The Chamber of Suppliers’ Development and Diversity (CSDD), a chamber
        for private contractors and suppliers of public goods and services, in
        collaboration with procurement consultancy firm, ProSupp Consult, has
        organized a one-day capacity-building training on competitive tendering
        procedures for its members at the Coconut Grove Regency Hotel in Accra.
        The workshop equipped participants with the requisite documentation and
        bargaining skills to enable them secure government contracts, and to
        execute them in the manner that ensures efficiency and value for money.
        About 30 participants, comprising of practitioners, individual business
        owners and procurement professionals drawn from the construction,
        information technology, general supply and printing sectors across the
        country took part in the informative and expertise sharing session. An
        associate consultant for the chamber, Mr. Dennis Teye-Adjei, told
        journalists that the training workshop was to groom its pool of members
        to become competent and ready tenderers for government works and
        contracts.
        <br />
        <br />
        <MKBox sx={{ textAlign: 'center', mb: 1 }}>
          <img
            style={{
              borderRadius: 10,
              width: '70%',
              height: '70%',
              objectFit: 'cover',
            }}
            src={article1}
            alt=''
          />
        </MKBox>
        He said: “This is a chamber to empower the private sector to secure
        contracts on merit by resourcing them with the right requirements for
        government goods and services.” According to Mr. Teye-Adjei, building
        expertise in the sourcing from the public space would ensure
        competition, fairness and equal access to securing government goods and
        services. “If the private sector is capacitated to get more money, they
        can grow and diversify their business, create employment and contribute
        to national development,” he added. Facilitator for the workshop, Mr.
        Kwame Oppong, emphasizing the need for the training, highlighted that
        about 60-70percent of tenders from private suppliers do not get to the
        evaluation stage because of issues relating to improper documentation.
        “We have observed as practitioners that most contractors and suppliers
        lose out on public tenders not on the basis of pricing but the mere fact
        that their documentations do not offer the right competition.
        <br />
        <br />
        This training was to equip participants with the requisite knowledge
        about the competitive tendering procedure and how they can prepare
        tender documents to meet the expectation of clients, and ultimately
        secure government contracts for goods and services,” he said. One of the
        participants, Mrs. Dorcas Asiedu, who owns a facility management,
        fumigation and landscaping firm, Docantree Limited, told journalists
        that she was greatly empowered by the training. “This training has been
        very informational and beneficial, especially for business owners like
        myself that secure contracts through competitive tendering. Personally,
        I’ve learned that it’s all about documentation, without which one could
        have the best bid price and still not secure any contracts. I recommend
        this session to both public and private sector actors who are into
        tendering and want to become very competitive and professional,” she
        indicated. Another participant, Mrs. Dorcas Felicity Brown, who is head
        of procurement for the Greater Accra Regional Hospital, shared her
        experience, highlighting the need for professionals to constantly build
        on their capacity as procurement people. “As a practitioner, I believe
        strongly that capacity building is very important that’s why I signed up
        for this training; I’ve learned so much about the right documentation
        procedures in the bidding for public goods and services,” she noted. She
        added: “In all, it’s been an educative and open-minded session that has
        opened me up to the new things about competitive tendering and I’ll
        recommend this training to all practitioners and tenderers who want to
        build their competence in their chosen profession.”
      </MKTypography>
    ),
  },
];

export default data;
